import axios from "axios";
import { API_BASE_URL } from "./apiBaseUrl";
import {redirect} from "next/navigation";
import {isUnderMaintance} from "@/src/shared/utils/isUnderMaintance";
import {MAINTANCE_ERROR} from "@/src/shared/const";
import {logError} from "@/src/api/server-actions/analytics";

export const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 503) {
            if (typeof window === "undefined") {
                throw new Error(MAINTANCE_ERROR);
            } else {
                logError("[axiosInstance] 503 received — redirecting to maintenance", error);
                window.location.href = "/maintance";
            }
        }
        return Promise.reject(error);
    }
);
